export const MODALS = {
  createEditBotModal: "createEditBotModal",
  attachFileToBotModal: "attachFileToBotModal",
  createDocumentModal: "createDocumentModal",
  createDocumentModalV2: "createDocumentModalV2",
  attachFileToDocumentModal: "attachFileToDocumentModal",
  onboardingModal: "onboardingModal",
  manageFriendsModal: "manageFriendsModal",
}